import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v4/user/info/`;

export const QueryKey = () => ['v4', 'user', 'info'] as const;

export type Payload = never;

export type Response = Models.UserInfo.User | null;
